// src/theme.ts
import { createTheme } from "@mui/material/styles";

// Criando um tema personalizado
const theme = createTheme({
  palette: {
    mode: "light", // Pode ser 'dark' ou 'light'
    primary: {
      main: "#26831D", // Cor principal
      light: "#3BAA30", // Cor mais clara
      dark: "#155B0E", // Cor mais escura
      contrastText: "#fff", // Cor do texto contrastante
    },
    secondary: {
      main: "#440109",
      light: "#730B17",
      dark: "#2D0005",
      contrastText: "#fff", // Cor do texto contrastante
    },
    background: {
      default: "#FAFAFA", // Cor de fundo geral
      paper: "#ffffff", // Cor de fundo dos elementos 'paper' (como cartões)
    },
    text: {
      primary: "#000000", // Cor do texto principal
      secondary: "#5f6368", // Cor do texto secundário
    },
  },
  typography: {
    fontFamily: "'Roboto', sans-serif", // Fonte padrão
    h1: {
      fontSize: "2.5rem", // Tamanho da fonte para h1
      fontWeight: 700, // Peso da fonte para h1
    },
    h2: {
      fontSize: "2rem", // Tamanho da fonte para h2
      fontWeight: 700, // Peso da fonte para h2
    },
    body1: {
      fontSize: "1rem", // Tamanho da fonte para o texto principal
      lineHeight: 1.5, // Espaçamento entre linhas
    },
  },
});

export default theme;
